/* JobCard Component */
import React from 'react';

const JobCard = ({ job, openModal, isOpen }) => {
  return (
    <div className={`job-card ${isOpen ? 'open' : ''}`}>
      {' '}
      <h2 className='job-title'>{job.title}</h2>
      <p className='job-desc'>{job.description}</p>
      <div className='job-btn-wrapper'>
        <button className='more-detail-btn' onClick={() => openModal(job)}>
          פרטים נוספים
        </button>
        <a href={job.link} target='_blank' rel='noopener noreferrer'>
          <button className='apply-btn'>הגשת מועמדות</button>
        </a>
      </div>
    </div>
  );
};

export default JobCard;
